import { useNavigate } from "react-router-dom";
import MobileFaqPage from "./MobileFaqPage";

/**
 * 고객용 FAQ/공지 화면은 NestJS v4 공개 콘텐츠 API만 사용한다.
 * Django 게시판 API로 직접 우회하지 않는다.
 */
export default function FaqList() {
    const navigate = useNavigate();

    return <MobileFaqPage onBack={() => navigate("/tabs/home")} />;
}
